/*
 | Ce fichier permet de contrôler les slides via fancybox
 | https://www.npmjs.com/package/@fancyapps/fancybox
 | http://fancyapps.com/fancybox/3/
 | Fancybox utilise JQuery.
 | Il est possible de déclencher l'utilisation de fancybox via les attributs data associé. (consulter la doc)
 | Dans le cas ou ce ne serait pas possible pour un cas spécifique, utiliser ce fichier pour déclarer les instances de fancybox.
 */
import "@fancyapps/fancybox/dist/jquery.fancybox.min.css"
import "@fancyapps/fancybox/dist/jquery.fancybox.min.js"

$.fancybox.defaults.thumbs.autoStart = true;

// Maintient des anciennes versions, si l'attribut data-caption n'est pas présent, on injecte le texte du l'attribut alt dedans
const TDFGalleryItems = document.querySelectorAll('[data-fancybox="gallery-tdf"]');
TDFGalleryItems.forEach(element => {

    if(!element.getAttribute('data-caption'))
    {
        element.setAttribute('data-caption', element.getAttribute('alt'))
    }
})

